import { getCookie, setCookie } from './cookies';

const COOKIE_AGREEMENT = 'isCookieUsageAgreed';

export const getCookieAgreement = () => getCookie(COOKIE_AGREEMENT);
export const setCookieAgreement = () => setCookie(COOKIE_AGREEMENT, 1);
